import Newsletter_42_Container from "./container/Newsletter_42_Container";
export default Newsletter_42_Container;
